import { PortalDsBadge, PortalDsBadgeVariant } from 'src/components/portal-design-system/portal-ds-badge';
import type { PacingBudgetStatus } from '../types/pacing-board.types';

const STATUS_LABELS: Record<PacingBudgetStatus, string> = {
  on_pace: 'On pace',
  behind_pace: 'Behind',
  ahead_pace: 'Ahead',
  critical_under: 'Critical',
  critical_over: 'Critical',
  not_started: 'Not started',
  ended: 'Ended',
  no_data: 'No data',
};

const STATUS_VARIANTS: Record<PacingBudgetStatus, PortalDsBadgeVariant> = {
  on_pace: 'green',
  behind_pace: 'amber',
  ahead_pace: 'amber',
  critical_under: 'red',
  critical_over: 'red',
  not_started: 'gray',
  ended: 'gray',
  no_data: 'gray',
};

interface PacingBoardStatusBadgeProps {
  status: PacingBudgetStatus | string | null | undefined;
}

export function formatPacingBoardStatusLabel(status: PacingBudgetStatus | string | null | undefined): string {
  if (!status) return 'Unknown';
  return STATUS_LABELS[status as PacingBudgetStatus] ?? String(status).replaceAll('_', ' ');
}

export default function PacingBoardStatusBadge({ status }: PacingBoardStatusBadgeProps) {
  const resolved = (status ?? 'no_data') as PacingBudgetStatus;
  return (
    <PortalDsBadge variant={STATUS_VARIANTS[resolved] ?? 'gray'} pill>
      {formatPacingBoardStatusLabel(resolved)}
    </PortalDsBadge>
  );
}
